import cn from 'classnames'
import { FC, useState } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { LoadingDots, Button } from '@corratech/pylot-ui'
import { Dropdown } from '@corratech/pylot-dropdown'
import { useWishlist } from '../Hooks/use-wishlist'
import { CreateWishlist } from '../CreateWishlist'
import { Plus, ChevronDown, ChevronUp } from 'react-feather'
import s from '@pagestyles/Wishlist.module.scss'

export type Props = {
    onClick: (id: number) => void
    isLoading?: boolean
    openDisplayLabel?: string
    closeDisplayLabel?: string
    showCreateWishlist?: boolean
    excludeIds?: string[]
    onCreate?: (id: number) => void
}

export const WishlistDropdown: FC<Props> = ({
    onClick,
    isLoading = false,
    openDisplayLabel = '', // this will not create any blank spaces
    closeDisplayLabel = '', // this will not create any blank spaces
    excludeIds,
    showCreateWishlist = true,
    onCreate
}) => {
    const { t } = useTranslation(['wishlist'])
    const [show, setShow] = useState(false)
    const { wishlists, loading } = useWishlist()
    const showCreate = () => setShow(true)

    //Loading dots used as inline loader
    if (loading) {
        return <LoadingDots />
    }

    const OpenDropdownArrow = () => {
        return (
            <span className={s['dropdown-label']}>
                {openDisplayLabel && (
                    <Button
                        type="button"
                        variant="link"
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        {openDisplayLabel}
                    </Button>
                )}
                <ChevronUp width="20" height="20" />
            </span>
        )
    }

    const CloseDropdownArrow = () => {
        return (
            <span className={s['dropdown-label']}>
                {closeDisplayLabel && (
                    <Button
                        type="button"
                        variant="link"
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        {closeDisplayLabel}
                    </Button>
                )}
                <ChevronDown width="20" height="20" />
            </span>
        )
    }

    return (
        <>
            <Dropdown
                openedDisplay={<OpenDropdownArrow />}
                closedDisplay={<CloseDropdownArrow />}
                className={cn(s['wishlist-dropdown'], 'animate-fade-in-up')}
                arrow
            >
                <ul>
                    {!!wishlists?.length &&
                        wishlists.map((wishlist, key) => {
                            if (!excludeIds?.includes(wishlist?.id!)) {
                                return (
                                    <li
                                        role="menuitem"
                                        key={key}
                                        onClick={() => {
                                            onClick(Number(wishlist?.id!))
                                        }}
                                        onKeyUp={() => {
                                            onClick(Number(wishlist?.id!))
                                        }}
                                    >
                                        {wishlist?.name}
                                    </li>
                                )
                            }
                        })}
                    {showCreateWishlist && (
                        <li className={s['create-wishlist-item']}>
                            <Plus width="14" height="20" />
                            <Button
                                onClick={showCreate}
                                onKeyUp={showCreate}
                                variant="link"
                            >
                                {t('wishlist|Create New Wish List')}
                            </Button>
                        </li>
                    )}
                </ul>
            </Dropdown>
            {showCreateWishlist && (
                <CreateWishlist
                    show={show}
                    setShow={setShow}
                    canRedirect={false}
                    onCreate={onCreate}
                />
            )}
        </>
    )
}
